// old version DO NOT USE
const BoardMember23 = ({ member }) => {
    return (
        <>
            <img src={member.imageSrc} alt={member.name} className="profile-pic" />
            <div className="description">
                <h2>{member.position}</h2>
                <p><strong>{member.name}</strong> <i>({member.pronouns})</i></p>
                <p>{member.ipa}</p>
                <br></br>
                <p>{member.major} {member.gradYear}</p>
                <br></br>
                <p><strong>Favorite Area of Ling:</strong></p>
                <p>{member.favoriteLingArea}</p>
                <br></br>
                <p><strong>Favorite Drink Order:</strong></p>
                <p>{member.favoriteDrink}</p>
            </div>
        </>
    );
};
export default BoardMember23;